export default {"src":"https://webcdn.trailways.ca/_next/static/media/trailways-small.74dbd89a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};